import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Xmldefs } from '../../../../../core/entities/xmldefs.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsXmldefsComponent } from './dialogs-xmldefs/edit-dialogs-xmldefs/edit-dialogs-xmldefs.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { CampsComponent } from './camps/camps.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-xmldefs',
  templateUrl: './xmldefs.component.html',
  styleUrls: ['./xmldefs.component.scss']
})
export class XmldefsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  xmldef: Xmldefs = new Xmldefs();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllXmldefs();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla xmldefs
  */
  private getAllXmldefs(): void {
    this.loading = true;
    this.internalHomeService.allXmldefs().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un xmldef
  * @param xmldef Opcional. Xmldef vacio.
  */
  public createXmldef(xmldef?: Xmldefs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    xmldef = this.xmldef;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsXmldefsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { xmldef, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllXmldefs();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un xmldef
  * @param xmldef Opcional. Xmldef a editar.
  */
  public editXmldef(xmldef?: Xmldefs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsXmldefsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { xmldef, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllXmldefs();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un xmldef
  * @param xmldef Xmldef a eliminar
  */
  public removeXmldef(xmldef?: Xmldefs) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_xmldefs') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeXmldefs(xmldef).subscribe(res => {
          console.log(res);
          this.getAllXmldefs();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un camps
  * @param xmldef Opcional. Xmldef.
  */
  public campsXmldef(xmldef?: Xmldefs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    console.log(xmldef);
    const dialogRef = this.dialog.open(CampsComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { xmldef, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Xmldefs) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
